import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/Button";
import { cn } from "@/lib/cn";

const nav = [
  { to: "/product/office", label: "Office" },
  { to: "/product/field", label: "Field" },
  { to: "/pricing", label: "Pricing" },
  { to: "/verticals/hvac", label: "Verticals" },
  { to: "/demo", label: "Demo" },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border/70 bg-surface/80 backdrop-blur-xl">
      <div className="container-page flex min-h-16 items-center justify-between gap-4 py-3">
        <Logo />

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "rounded-full px-3.5 py-2 text-sm font-medium text-muted transition hover:bg-surface-muted hover:text-fg",
                  isActive && "bg-surface-muted text-fg",
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <Button to="/signup" variant="ghost" size="md">
            Sign up
          </Button>
          <Button to="/demo" size="md">
            Book a demo
          </Button>
        </div>

        <button
          type="button"
          className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full border border-border bg-surface-raised lg:hidden"
          aria-expanded={open}
          aria-controls="mobile-nav"
          onClick={() => setOpen((value) => !value)}
        >
          <span className="sr-only">Toggle menu</span>
          <span aria-hidden className="flex w-5 flex-col gap-1.5">
            <span className="block h-0.5 rounded bg-fg" />
            <span className="block h-0.5 rounded bg-fg" />
            <span className="block h-0.5 rounded bg-fg" />
          </span>
        </button>
      </div>

      {open && (
        <div
          id="mobile-nav"
          className="border-t border-border bg-surface-raised px-4 py-4 lg:hidden"
        >
          <nav className="flex flex-col gap-1" aria-label="Mobile">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="rounded-xl px-3 py-3 text-base font-medium text-fg hover:bg-surface-muted"
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-4 grid gap-2">
            <Button to="/signup" variant="secondary" onClick={() => setOpen(false)}>
              Sign up
            </Button>
            <Button to="/demo" onClick={() => setOpen(false)}>
              Book a demo
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
